import OccupacyDetails from "./OccupacyDetails";
export default OccupacyDetails;